@if (product()) {
  <div class="section product-info" *onlyForScreens="['desktop']">
    <app-checkout-sidebar [product]="product()" [startTrialMode]="startTrialMode()"></app-checkout-sidebar>
  </div>
  <div class="checkout-container">
    <app-checkout
      [product]="product()"
      [initialBillingFrequency]="billingFrequency"
      [newPromotion]="promo"
      [endTrialEarly]="false"
    ></app-checkout>
  </div>
}
